import defineProgress from './defineProgress'
import ProgressComponent from './ProgressComponent'

const Progress = defineProgress()

export { Progress, ProgressComponent }
